module.exports = __webpack_public_path__ + "static/media/logo.3dce5971.svg";